import axios from "axios";
import { base_url } from "../../utils/baseUrl";



const getGlobalGallerys = async () => {
  
  const response = await axios.get(`${base_url}globalGallery/getAllGlobalGallerys`);
 
  return response.data;
  
};
const createGlobalGallery = async (values) => {
  const response = await axios.post(`${base_url}globalGallery/createGlobalGallery`,values);

  return response.data;
};

const updateGlobalGallery = async (values) => {
  const id = values.get("id") 
  const response = await axios.put(
    `${base_url}updateGlobalGallery/updateAd/${id}`,
    values,

  );

  return response.data;
};

const getGlobalGallery = async (id) => {
  const response = await axios.get(`${base_url}globalGallery/getById/${id}`);

  return response.data;
};

const deleteGlobalGallery = async (id) => {
  const response = await axios.delete(`${base_url}globalGallery/deleteGlobalGallery/${id}`);

  return response.data;
};
const GlobalGalleryService = {
  getGlobalGallerys,
  createGlobalGallery,
  getGlobalGallery,
  updateGlobalGallery,
  deleteGlobalGallery,
};

export default GlobalGalleryService;
